<template class="text_google">
  <v-app>
    <v-system-bar
      class="noprint"
      color="grey darken-2"
      dark
      height="40"
      app
      lights-out
    >
      <v-toolbar-items class="ml-5">
        <v-btn
          href="javascript:window.print()"
          class="title elevation-0 mr-2"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-printer</v-icon>&nbsp; พิมพ์
        </v-btn>
        <v-btn
          @click.stop="Export2Doc('exportContent', 'word-content')"
          class="title elevation-0"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>
    <div id="exportContent" style="mso-page-orientation: landscape;">
      <div class="page">
        <div align="center">
          <v-img
            max-height="30mm"
            max-width="25mm"
            src="krud.jpg"
          ></v-img>
          <div class="head">
            แบบรายงานข้อมูลเงื่อนไขสาขาวิชาเอก ประกอบการพิจารณาย้ายข้าราชการ
            ประจำปี {{ conditions_transfers.year_s }} ครั้งที่
            {{ conditions_transfers.time_s }}
          </div>
          <div class="head">
            ส่งมาพร้อมกับหนังสือ
            {{ colleges_user.college_name }}
            ที่...........................ลงวันที่
            ..................................
          </div>
          <div>___________________________</div>
        </div>
        <table border="0" width="100%" align="center">
          <tr>
            <td width="5%" class="regular16">เรียน</td>
            <td width="95%" class="regular16">
              เลขาธิการคณะกรรมการการอาชีวศึกษา
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%" class="regular16"></td>
            <td width="80%" class="regular16">
              ตามที่สำนักงานคณะกรรมการการอาชีวศึกษา
              ขอทราบข้อมูลเงื่อนไขสาขาวิชาเอก
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="100%" class="regular16">
              เพื่อใช้ประกอบการพิจารณาย้ายข้าราชการครู ประจำปี
              {{ conditions_transfers.year_s }} ครั้งที่
              {{ conditions_transfers.time_s }} นั้น
              {{ colleges_user.college_name }}
              ได้จัดประชุมคณะกรรมการสถานศึกษาแล้ว
              มีมติให้จัดความต้องการครูในสาขาวิชา ดังต่อไปนี้
            </td>
          </tr>
        </table>

        <br />
        <table width="100%" align="center" class="table">
          <tr>
            <th width="10%" class="regular16 " align="center">รหัสสาขา</th>
            <th width="25%" class="regular16 " align="left">สาขาวิชา</th>
            <th width="10%" class="regular16 th" align="center">จำนวนรับ</th>
            <th width="10%" class="regular16 th" align="center">หมายเหตุ</th>
          </tr>
        </table>

        <table
          width="100%"
          align="center"
          class="table"
          v-for="item in conditions_branchs"
          :key="item.id"
          small
        >
          <tr>
            <td width="10%" class="regular12 " align="center">
              {{ item.id_branch }}
            </td>
            <td width="25%" class="regular12 ">
             {{ item.name_branch }}
            </td>
            <td width="10%" class="regular12 th" align="center">
              {{ item.quantity_n }}
            </td>

              <td width="10%" class="regular12 th" align="center">
              {{ item.con_datail_branch }}
            </td>

          </tr>
        </table>

        <table border="0" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td width="40%">
              <div class="regular16">
                <span class="regular16"
                  >ข้อมูล ณ วันที่ {{ conditions_transfers.date_time }}</span
                >
              </div>
            </td>
          </tr>
        </table>

        <br />
        <table border="0" width="100%" align="center" class="text_j">
          <tr>
            <td width="60%"></td>
            <td width="40%">
              <div class="regular16">
                ลงชื่อ.............................................................
              </div>
            </td>
          </tr>
          <tr>
            <td width="60%"></td>
            <td width="40%" align="center">
              <div class="regular16">
                (..........................................................)
              </div>
            </td>
          </tr>
          <tr>
            <td width="60%"></td>
            <td width="40%" align="center">
              <div class="regular16">ผู้รายงาน</div>
            </td>
          </tr>
        </table>

        <br /><br />
        <table border="0" width="100%" align="center" class="text_j">
          <tr>
            <td width="60%"></td>
            <td width="40%">
              <div class="regular16">
                ลงชื่อ.............................................................
              </div>
            </td>
          </tr>
          <tr>
            <td width="60%"></td>
            <td width="40%" align="center">
              <div class="regular16">
                (.....{{ colleges_user.collegeinfo_director }}.....)
              </div>
            </td>
          </tr>
          <tr>
            <td width="60%"></td>
            <td width="40%" align="center">
              <div class="regular16">
                ผู้อำนวยการ{{ colleges_user.college_name }}
              </div>
            </td>
          </tr>
        </table>

      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    personnel_temporarys: [],
    transference_personnels: [],
    personnel_educations: [],
    transference_locations: [],
    conditions_transfers: [],
    conditions_branchs: [],
    personnel_temporarys_switch: [],
    province_sh_s: [],
    province_sh_fm: [],
    province_sh_m: [],
    colleges_user: [],
    valid: true,  
    user: {},
    loading: true,
    dialogLoading: true,
    interval: {},
    value: 0
  }),

  async mounted() {
    await this.sweetAlertLoading();    
    await this.conditions_transferQueryAll();
    await this.conditions_branchQueryAll();
    await this.personnel_temporaryQueryAll();
    Swal.close();
  },
  methods: {
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async personnel_temporaryQueryAll() {   
      this.loading = true;
      let result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey,
        college_code: this.conditions_transfers.college_code
      });
      this.colleges_user = result.data;   
    },

    async conditions_branchQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditions_branch.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        })
        .finally(() => (this.loading = false));
      this.conditions_branchs = result.data;
    },

    async conditions_transferQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditions_transfer.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = result.data;   
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },
  props: {
    source: String
  },

  computed: {
    id_ref() {
      return this.$route.query.id_ref;
    },

   

    month_now() {
      const d = new Date();
      let month = d.getMonth() + 1;
      return month;
    },
    year_s() {
      const d = new Date();
      let year = d.getFullYear();
      return year;
    },
    time_s() {
      let time_m;
      if (this.month_now > 2) {
        time_m = 2;
      } else {
        time_m = 1;
      }
      return time_m;
    },  

  }
};
</script>
<style scoped>
@import url(
  https://fonts.googleapis.com/css?family=Prompt:400,
  300|Roboto:400,
  300&subset=latin,
  thai
);

body {
  font-family: "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
}

.text_j {
  border-collapse: collapse;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1.5cm;
  padding-right: 1.5cm;
  padding-bottom: 1.75cm;
  padding-left: 2cm;
}

.head {
  font-family: "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
    height: 247mm;
  }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
      font-size: 18px;
      font-weight: bold;
    }
    .regular12 {
      font-size: 12px;
    }
    .blod12 {
      font-size: 12px;
      font-weight: bold;
    }
    .blackRegula8 {
      font-size: 8px;
    } */
  .noprint {
    display: none;
  }
}
</style>
